export default "__VITE_ASSET__DzxnxlS3__"